// THIS FILE USES 'react-toastify' PACKAGE
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './notif.css';
const notifOption = { 
  position: 'bottom-right', 
  autoClose: 4 * 1000,
  hideProgressBar: true, 
  theme: 'colored' 
};

const addNotif = (message, type) => {
  switch(type) {
    case 'success':
      toast.success(message, notifOption);
      break;
    case 'error':
      toast.error(message, notifOption);
      break;
    case 'warn':
      toast.warn(message, notifOption);
      break;
    case 'notif':
    default:
      toast.info(message, notifOption);
      break;
  }
}

export { addNotif };